import React, { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { FormCardData } from '../../types/types';
import SwitchButton from '../../components/switchButton/switchButton';
import ModalMessage from './modalMessage/modalMessage';
import './_form.scss';

type FormProps = {
  onSubmit: (submitData: FormCardData) => void;
};

interface IFormInputs {
  input: string;
  dateInput: string;
  dropdown: string;
  fileInput: FileList;
  checkbox: string;
}

export default function Form(props: FormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
  } = useForm<IFormInputs>();

  const [showModal, setShowModal] = useState(false);
  const [gender, setGender] = useState('male');

  const setGenderValue = () => {
    const newGenderValue = gender === 'male' ? 'female' : 'male';
    setGender(newGenderValue);
  };

  const showModalMsg = async () => {
    await setShowModal(true);
    setTimeout(() => setShowModal(false), 3000);
  };

  const clearForm = () => {
    reset();
    setGender('male');
  };

  const onSubmit: SubmitHandler<IFormInputs> = (data) => {
    const { onSubmit } = props;
    const cardData = {
      name: data.input,
      date: data.dateInput,
      city: data.dropdown,
      gender: gender,
      fileName: ((data.fileInput as FileList).item(0) as File).name,
    };
    showModalMsg();
    clearForm();
    onSubmit(cardData);
  };

  return (
    <form className="form" data-testid="form" onSubmit={handleSubmit(onSubmit)}>
      <label>
        Name
        <input
          type="text"
          {...register('input', {
            required: 'Cannot be empty',
            pattern: { value: /^[a-zA-Zа-яА-Я]+$/i, message: 'Only letters' },
          })}
          className={errors.input ? 'error' : ''}
        />
        <span className="form__error">{errors.input && errors.input.message}</span>
      </label>
      <label>
        Birthday
        <input
          type="date"
          {...register('dateInput', { required: 'Cannot be empty' })}
          className={errors.dateInput ? 'error' : ''}
        />
        <span className="form__error">{errors.dateInput && errors.dateInput.message}</span>
      </label>
      <label>
        Choose city
        <select
          {...register('dropdown', { required: 'Choose country' })}
          className={errors.dropdown ? 'error' : ''}
          defaultValue={''}
        >
          <option value="" disabled>
            Select country
          </option>
          <option value="Boston">Boston</option>
          <option value="Cambridge">Cambridge</option>
          <option value="New York">New York</option>
          <option value="Detroit">Detroit</option>
        </select>
        <span className="form__error">{errors.dropdown && errors.dropdown.message}</span>
      </label>
      <div className="form__switch">
        <div className="switch__title">Choose gender</div>
        <SwitchButton isOn={gender === 'female'} handleToggle={setGenderValue} />
      </div>
      <label>
        Upload file
        <input
          type="file"
          {...register('fileInput', { required: 'Add file' })}
          className={errors.fileInput ? 'error' : ''}
        />
        <span className="form__error">{errors.fileInput && errors.fileInput.message}</span>
      </label>
      <div className="form__checkbox">
        <label className="form__checkbox-label">
          <input
            type="checkbox"
            {...register('checkbox', { required: 'Give your consent' })}
            className={errors.checkbox ? 'error' : ''}
          />
          I consent to my personal data
          <br />
        </label>
        <div className="form__error">{errors.checkbox && errors.checkbox.message}</div>
      </div>

      <input
        className="form__submit"
        type="submit"
        value="Submit"
        disabled={!isDirty || !(Object.keys(errors).length === 0)}
      />
      <ModalMessage show={showModal} />
    </form>
  );
}
